import React from 'react';
import CheckBox from '../../Basic/CheckBox';

class EmailNotificationConfirm extends React.Component {
  render() {
    const lookup = window.osa && window.osa.commonLookup && window.osa.commonLookup.userProfile;
    const message = lookup && lookup.userProfileMessage + "<a target='_blank' href='http://www.fortisbc.com/Pages/privacypolicy.aspx'> Privacy Policy</a> or <a href='http://www.fortisbc.com/ContactUs/Pages/default.aspx' target='_blank'>contact us</a> for more details.";
    return (
      <div>
        {
         this.props.isRegister ?
          <div className="col-sm-12" >
            <h4 className="text-primary">Confirm you would like to receive electronic communications from FortisBC.</h4>
            <h5>We require your consent to receive electronic communications from us. You can unsubscribe at any time by clicking the unsubscribe link included in all email communications.</h5>
            <h5>Please confirm all of the types of communications you wish to receive from FortisBC.</h5>
            <label>Confirmation</label>
          </div>
        : null
        }
        <div className="col-sm-12" >
          <div className="form-group">
            <CheckBox name="profileNotificationEmail" title={lookup && lookup.userProfileIAgree} required />
          </div>
        </div>
        <div className="col-sm-12" >
          <div className="form-group">
            <CheckBox name="profileUpdatesEmail" title={message} />
          </div>
        </div>
         {
            !this.props.isRegister ?
        <div className="col-sm-12" >
          <div className="form-group">
            <p>{lookup && lookup.userProfileNote}</p>
          </div>
        </div>
        :null
         }
      </div>
    );
  }
}
export default EmailNotificationConfirm;

